import { ChipStyled } from './chip.styled.js'
import MuiChip from '@mui/material/Chip'
import { string } from 'prop-types'

const Chip = (props) => {
	return <ChipStyled {...props} />
}

Chip.defaultProps = {
	...MuiChip.defaultProps,
	color: '#e1e1e1',
	textColor: '#141416',
}

Chip.propTypes = {
	...MuiChip.propTypes,
	/**
	 * Background color
	 */
	color: string,
	/**
	 * Text color
	 */
	textColor: string,
}

export default Chip
